import { render, staticRenderFns } from "./network.vue?vue&type=template&id=b98c667a&scoped=true"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"
import style0 from "./network.vue?vue&type=style&index=0&id=b98c667a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c667a",
  null
  
)

export default component.exports